import { motion } from "framer-motion";
import { Map, Timer, Crosshair, ShieldCheck, RefreshCw } from "lucide-react";

const icons = [Map, Timer, Crosshair, ShieldCheck, RefreshCw];

export const GtaSystem = ({ t }) => (
  <section id="system" data-testid="system-section" className="relative overflow-hidden py-24 lg:py-32">
    <div className="pointer-events-none absolute right-0 top-0 h-96 w-96 rounded-full bg-[#EAB308]/10 blur-[130px]" />
    <div className="mx-auto max-w-7xl px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
        className="max-w-3xl"
      >
        <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-[#EAB308]">{t.system.eyebrow}</p>
        <h2 className="mt-4 text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">{t.system.headline}</h2>
        <p className="mt-4 text-base text-gray-400 md:text-lg">{t.system.sub}</p>
      </motion.div>

      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {t.system.steps.map((s, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={i}
              data-testid={`system-step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0C1732] p-6 transition-[border-color,transform] duration-300 hover:-translate-y-1.5 hover:border-[#EAB308]/40"
            >
              <span className="font-mono-num text-sm font-bold text-white/20">{s.n}</span>
              <div className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#EAB308]/15 transition-colors duration-300 group-hover:bg-[#EAB308]/25">
                <Icon className="h-5 w-5 text-[#EAB308]" />
              </div>
              <h3 className="mt-5 font-mono-num text-lg font-bold tracking-[0.15em] text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-400">{s.text}</p>
              {i < t.system.steps.length - 1 && (
                <span className="absolute right-4 top-1/2 hidden h-px w-6 -translate-y-1/2 bg-gradient-to-r from-[#EAB308]/50 to-transparent lg:block" />
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
